define('app/controllers/propietaris',['angular', 'app/services/shared'], function(angular) {
  var module = angular.module('app.propietaris', ['app.shared']);

  module.controller('PropietariNewController', [
    '$scope',
    '$http',
    '$route',
    '$location',
    '$filter',
    'sharedProperties',
    'actionFactory',
    'consumer',
    'state',
    'info',
    'elem',
    'elems',
	'extrainfo',
    function($scope, $http, $route, $location, $filter, sharedProperties, actionFactory, consumer, state, info, elem, elems, extrainfo) {
      var api_base_url = sharedProperties.getApiBaseUrl();

      $scope.actions = state.elemActions;
      $scope.state = state.state;
      $scope.elem = {};
      $scope.elem.Finques = [];
      $scope.finca = {};
      $scope.elems = elems;
	  $scope.extrainfo = extrainfo;

      $scope.setSelected = function(ndx) {
        $scope.finca = $scope.elem.Finques[ndx];
      };

      $scope.addFinca = function(ndx) {
        var newFinca = {};
        $scope.elem.Finques.push(newFinca);
        $scope.finca = newFinca;
      };

      $scope.$on('naction', function (event, action, id) {
        $scope.error = false;

        var promise = consumer.consumeAction(action, id, $scope.elem, $route.current.params);
        promise.then(function (retVal) {
          if (retVal.processed && retVal.refresh && retVal.elem) {
            $scope.producte = retVal.elem;
            actionFactory.updateItemActions(info, state.elemActions, id);
          }
        }, function (reason) {
          $scope.error = true;
          $scope.errorMessage = sharedProperties.getErrorMessage(reason);
          console.log('Failed', reason);
        }, function (update) {
          console.log('Got notification', update);
        })
      });

    }
  ]);


  module.controller('PropietariEditController', [
    '$scope',
    '$http',
    '$route',
    '$location',
    '$filter',
    'sharedProperties',
    'actionFactory',
    'consumer',
    'state',
    'info',
    'elem',
    'elems',
    function($scope, $http, $route, $location, $filter, sharedProperties, actionFactory, consumer, state, info, elem, elems) {
      var api_base_url = sharedProperties.getApiBaseUrl();

      $scope.elemId = info.isInt ? parseInt($route.current.params.id):$route.current.params.id;
      $scope.actions = state.elemActions;
      $scope.state = state.state;
      $scope.elem = elem;
      $scope.elems = elems;
      actionFactory.complementActions(info, $scope.actions, $scope.elemId);

      $scope.finca = $scope.elem.Finques[0] || {};

      $scope.setSelected = function(ndx) {
        $scope.finca = $scope.elem.Finques[ndx];
      };

      $scope.addFinca = function(ndx) {
        var newFinca = {};
        $scope.elem.Finques.push(newFinca);
        $scope.finca = newFinca;
      };

      $scope.$on('naction', function (event, action, id) {
        $scope.error = false;

        var promise = consumer.consumeAction(action, id, $scope.elem, $route.current.params);
        promise.then(function (retVal) {
          if (retVal.processed && retVal.refresh && retVal.elem) {
            $scope.producte = retVal.elem;
            actionFactory.updateItemActions(info, state.elemActions, id);
          }
        }, function (reason) {
          $scope.error = true;
          $scope.errorMessage = sharedProperties.getErrorMessage(reason);
          console.log('Failed', reason);
        }, function (update) {
          console.log('Got notification', update);
        })
      });


    }
  ]);


  return module;
});
